export const initialAssetsState: OverlayAssetsState = {
	assets: {},
	uploads: {},
};
